import React from "react";
import { Avatar } from "antd";
import { getInitials } from "../../utils/utils";

const UserAvatar = ({ data }) => {
  if (!data) return null;

  return (
    <div className="flex items-center gap-3">
      <div>
        <Avatar
          size="large"
          className={`uppercase ${!data?.profile_image ? "bg-gray-400" : ""}`}
          src={data?.profile_image}
        >
          {getInitials(data?.name)}
        </Avatar>
      </div>

      <div>
        <p className="sub-title">{data?.name}</p>
        <p className="text-Gray">{data?.email}</p>
      </div>
    </div>
  );
};

export default UserAvatar;
